export default "__VITE_ASSET__BvdldyYw__"